import { Reducer } from "redux";
import { PlayerPageState } from "../constants";
import { PlayerPageActions, PlayerPageActionTypes } from "../actions/types";

const initialState: PlayerPageState = {
  players: {},
  playerCards: {},
  playerCareers: {},
  playerMatches: {},
  playerSeasonStats: {},
  status: "idle",
  error: null,
};

const reducer: Reducer<PlayerPageState> = (
  state = initialState,
  action: PlayerPageActions
) => {
  switch (action.type) {
    case PlayerPageActionTypes.RESET:
      return initialState;

    case PlayerPageActionTypes.FETCH_PLAYER:
    case PlayerPageActionTypes.FETCH_PLAYER_CARD:
    case PlayerPageActionTypes.FETCH_PLAYER_CAREER:
    case PlayerPageActionTypes.FETCH_PLAYER_MATCHES:
    case PlayerPageActionTypes.FETCH_PLAYER_SEASON:
      return { ...state, status: "loading" };

    case PlayerPageActionTypes.FETCH_PLAYER_SUCCESS: {
      const { id, response, fetchDate } = action.payload;
      return {
        ...state,
        status: "idle",
        players: {
          ...state.players,
          [id as number]: { id, response, fetchDate },
        },
      };
    }

    case PlayerPageActionTypes.FETCH_PLAYER_CARD_SUCCESS: {
      const { id, response, fetchDate } = action.payload;
      return {
        ...state,
        status: "idle",
        playerCards: {
          ...state.playerCards,
          [id as number]: { id, response, fetchDate },
        },
      };
    }

    case PlayerPageActionTypes.FETCH_PLAYER_CAREER_SUCCESS: {
      const { id, response, fetchDate } = action.payload;
      return {
        ...state,
        status: "idle",
        playerCareers: {
          ...state.playerCareers,
          [id as number]: { id, response, fetchDate },
        },
      };
    }

    case PlayerPageActionTypes.FETCH_PLAYER_MATCHES_SUCCESS: {
      const { id, response, fetchDate } = action.payload;
      return {
        ...state,
        status: "idle",
        playerMatches: {
          ...state.playerMatches,
          [id as number]: { id, response, fetchDate },
        },
      };
    }

    case PlayerPageActionTypes.FETCH_PLAYER_SEASON_SUCCESS: {
      const { key, response, fetchDate } = action.payload;
      return {
        ...state,
        status: "idle",
        playerSeasonStats: {
          ...state.playerSeasonStats,
          [key]: { response, fetchDate },
        },
      };
    }

    case PlayerPageActionTypes.FETCH_ERROR:
      return { ...state, status: "failed", error: action.payload };

    default:
      return state;
  }
};

export { reducer as playerReducer };

